// Styles here will override Bulma styles
import { css } from '@emotion/core';
import media, { setBreakPoints } from 'css-in-js-media';
import styled from '@emotion/styled';

setBreakPoints({ phone: 453 });

export const styledHeroTextSection = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 120px;
  padding-bottom: 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;

  ${media('<tablet')} {
    padding-top: 64px;
    padding-bottom: 64px;
    min-height: 360px;
    height: 100%;
  }
`;

export const styledHeroTextFullscreen = css`
  height: calc(100vh - 305px);
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media('<desktop')} {
    height: calc(100vh - 195px);
  }
`;

export const styledCenterHeroText = css`
  line-height: 120% !important;

  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0 auto;
  }

  ${media('<desktop')} {
    width: inherit;
    max-width: inherit;
  }
`;

export const styledButtonContainer = css`
  margin-top: 40px;

  a,
  button {
    margin-right: 0 !important;
  }

  a:nth-of-type(2),
  button:nth-of-type(2) {
    margin-left: 24px;

    ${media('<=phone')} {
      margin-left: 0;
      margin-top: 16px;
    }
  }
`;

export const styledHeading = css`
  max-width: 670px;
  line-height: 110% !important;
`;

export const styledSubHeading = css`
  max-width: 670px !important;
`;

export const HeroTextContentContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;

  ${media('<tablet')} {
    flex-wrap: wrap;
    text-align: center;
  }
`;

export const HeroTextFormContainer = styled.div`
  width: 32%;
  max-width: 370px;

  ${media('<tablet')} {
    width: 100%;
    margin: 0 auto;
  }
`;

export const heroTextNoForm = css`
  width: 100%;
  text-align: center;
`;

export const heroTextForm = css`
  width: 64%;
  margin-right: 2%;

  ${media('<tablet')} {
    width: 100%;
    margin-bottom: 50px;
    margin-right: 0;
  }
`;

export const styledHeroBox = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 370px;
  margin: 0;
  border-radius: 6px;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    text-align: center;
    padding: 32px;
  }

  ${media('<desktop')} {
    min-width: 320px;
    max-width: 370px;
    margin-top: 32px;
  }
`;

export const styledHeroBoxTitle = css`
  flex: 0 !important;
  width: 100%;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  background-color: #f3f5f9;
  padding: 16px 0 12px 0;

  h5 {
    margin-top: 0px;
    display: flex;
    align-items: center;
    height: 36px;
  }
`;

export const StyledForm = styled.form`
  .form-wrapper {
    display: inline-block;
    text-align: left;
  }

  .hide-error {
    display: none;
  }

  .show-error {
    display: block;
  }

  input {
    width: 100%;
    height: 48px;
    border: 1px solid #e5e8ed;
    box-sizing: border-box;
    border-radius: 3px;
    margin-bottom: 8px;

    font-family: 'WorkSans-Regular';
    font-size: 16px;
    padding: 16px;
    color: #031b4e;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    :focus {
      border-color: #0069ff;
      outline: #0069ff;
    }
  }

  input.error-border {
    border: solid 1px #ca0c0c;
  }

  input[type='submit'] {
    background: #0069ff;
    border: none;
    line-height: 100%;
    font-family: 'WorkSans-Bold';
    color: #fff;
    padding: 17px;
    cursor: pointer;
    margin-bottom: 0;
  }

  span.error-text {
    color: #ca0c0c;
    display: inline-block;
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    margin-bottom: 16px;
    text-align: left;
  }
`;

export const styledSubmit = css`
  width: 100%;
`;

export const StyledButtonsContainer = styled.div`
  border-top: 1px solid #f3f5f9;
  width: 306px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
`;

export const StyledButtonsContainerHr = styled.div`
  border-top: 1px solid #f3f5f9;
  width: 100%;
  padding: 32px 0 0 0;
`;

export const styledButton = css`
  height: 48px;
  padding: 16px;
  margin: 0;
  border: 1px solid #0069ff;
`;

export const styledButtonWText = css`
  height: 48px;
  padding: 13px 30px 16px 30px;
  margin: 0;
  display: flex;
  align-items: flex-start;
  border: 1px solid #0069ff;
  color: #0069ff;

  img {
    margin-top: 1px;
    margin-right: 6px;
  }
`;

export const StyledSubscript = styled.div`
  max-width: 370px;
  min-width: 370px;

  ${media('<desktop')} {
    min-width: 320px;
    max-width: 370px;
  }

  p,
  a {
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    text-align: center;
    color: #fff;
  }

  a:hover {
    color: white !important;
    border-bottom: dotted 1px rgba(255, 255, 255, 0.5);
  }
`;
